"use client";

import { useState } from "react";
import { handleError } from "@/lib/apiUtils";
import { useSearchParams } from "next/navigation";
import { emailSignIn } from "@/lib/signInUtils";
import { CookieName } from "@/types/nextCookie";
import posthog from "posthog-js";

const useLandingPageInvite = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const searchParams = useSearchParams();

  const joinWaitlist = async (emailAddress: string) => {
    try {
      setLoading(true);

      const sourceParams: Record<string, string> = {};
      searchParams.forEach((value, key) => {
        const cleanKey = key.replace(/^\?/, "");
        sourceParams[cleanKey] = value;
      });

      if (Object.keys(sourceParams).length > 0) {
        document.cookie = `${CookieName.SOURCE_PARAMS}=${JSON.stringify(sourceParams)}; path=/; max-age=3600; SameSite=Lax`;
      }

      // Build callback URL for the ads flow
      const callbackUrl = new URL("/onboarding", window.location.origin);
      callbackUrl.searchParams.set("webview", "true");

      // Use NextAuth email provider (with retry); on success it redirects.
      // We mark submitted=true before navigating so that if the navigation is
      // blocked (e.g. an in-app browser intercepts window.location.assign) the
      // user sees a "check your email" message rather than a silently cleared form.
      await emailSignIn(emailAddress, callbackUrl.toString());
      setLoading(false);
      setSubmitted(true);
      posthog.identify(emailAddress);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  return {
    loading,
    submitted,
    joinWaitlist,
  };
};

export default useLandingPageInvite;
